module.exports = __webpack_public_path__ + "img/Ring-as.023f1dad.jpeg";